<template>
  <div
    class="l-fullscreen"
    v-show="isShowFullscreenIcon"
    ref="floatButton"
    :style="{ left: left + 'px', top: top + 'px' }"
  >
    <span
      :class="{
        'icon-lily': true,
        'icon-lily-quanping': !fullscreen,
        'icon-lily-quxiaoquanping': fullscreen,
        'icon-size': true,
      }"
      @click="onHandleFullScreen"
      v-if="!tribeFlag"
    ></span>
  </div>
</template>

<script>
import version from "@/utils/version";
export default {
  data() {
    return {
      isShowFullscreenIcon: false,
      fullscreen: false,
      tribeFlag: window.JSBridge.platform().isTribe, // 内嵌标识符
      left: 0,
      top: 120,
    };
  },
  methods: {
    onHandleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.fullscreen = false;
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
        this.fullscreen = true;
      }
    },
  },
  mounted() {
    //是否展示全屏按钮
    if (version.isPC()) {
      this.isShowFullscreenIcon = false;
    } else {
      this.isShowFullscreenIcon = true;
      const floatButton = this.$refs.floatButton;
      floatButton.addEventListener("touchstart", () => {
        floatButton.style.transition = "none";
      });
      // 在拖拽的过程中，组件应该跟随手指的移动而移动。
      floatButton.addEventListener("touchmove", (e) => {
        if (e.targetTouches.length === 1) {
          let touch = e.targetTouches[0];
          this.left = touch.clientX - 20;
          this.top = touch.clientY - 20;
        }
      });
      // 拖拽结束以后，重新调整组件的位置并重新设置过度动画。
      floatButton.addEventListener("touchend", () => {
        floatButton.style.transition = "all 0.3s";
        if (this.left > document.documentElement.clientWidth / 2) {
          this.left =
            document.documentElement.clientWidth - floatButton.clientWidth;
        } else {
          this.left = 0;
        }
        if (
          this.top >
          document.documentElement.clientHeight - floatButton.clientHeight
        ) {
          this.top =
            document.documentElement.clientHeight - floatButton.clientHeight;
        }
        if (this.top < 50) {
          this.top = 50;
        }
      });
    }
  },
};
</script>

<style lang="stylus">
@import './index.styl'
</style>
